import { Action } from '../../../../components/MultipleActionsInterfaces';
import LangEnum from '../../../../lang/LangEnum';
import { CatalogListMassActionType } from '../../hooks/types/useCatalogListMassActions.types';

interface CatalogBulkActionConfig {
  type: CatalogListMassActionType;
  label: LangEnum;
  icon: React.ElementType;
  active: boolean;
}

export function catalogBulkAction({
  type,
  label,
  icon,
  active,
}: CatalogBulkActionConfig): Action<CatalogListMassActionType> {
  return {
    label,
    type,
    icon,
    active,
    isMassAction: true,
    showShortcut: false,
  };
}
